<template>
  <div class="container-navbar header-min">
    <b-container>
      <b-row class="d-none d-print-block">
        <b-col
          cols="12" class="pt-4 pl-md-4">
          <Logo></Logo>
        </b-col>
      </b-row>
      <b-navbar toggleable="xxl">
        <template v-if="!['Lesson', 'teachersLessonsBlackBoard', 'teachersLessonsProjector', 'teachersLessons'].includes($route.name)">
          <template v-if="!specialCase.includes($route.params.documentid)">
            <b-navbar-brand :to="{name: 'Home'}">
              <Logo></Logo>
            </b-navbar-brand>
          </template>
        </template>

        <template v-if="['Lesson'].includes($route.name)">
          <b-navbar-nav is-nav class="mr-auto nav-section">
            <b-nav-item :to="{name: 'Students'}" class="backTo"><font-awesome-icon icon="arrow-left" /> For students</b-nav-item>
          </b-navbar-nav>
        </template>
        <template v-if="['teachersLessonsBlackBoard', 'teachersLessonsProjector', 'teachersLessons', 'otherContent'].includes($route.name)">
          <template v-if="specialCase.includes($route.params.documentid) || ['teachersLessonsBlackBoard', 'teachersLessonsProjector', 'teachersLessons'].includes($route.name)">
            <b-navbar-nav is-nav class="mr-auto nav-section">
              <b-nav-item :to="{name: 'Teachers'}" class="backTo"><font-awesome-icon icon="arrow-left" /> For teachers</b-nav-item>
              <template v-if="!['otherContent'].includes($route.name)">
                <b-nav-text class="pipe d-none d-md-block">|</b-nav-text>
                <b-nav-text class="lesson-type d-none d-md-block">
                  <template v-if="['teachersLessonsBlackBoard'].includes($route.name)">
                    Blackboard lesson plan
                  </template>
                  <template v-else-if="['teachersLessonsProjector'].includes($route.name)">
                    Projector lesson plan
                  </template>
                  <template v-else>
                    Computer-based lesson plan
                  </template>
                </b-nav-text>
              </template>
            </b-navbar-nav>
          </template>
        </template>

        <b-navbar-toggle target="sidebarMenu" v-if="showMenu === 'TRUE'">
          <template>
            MENU <font-awesome-icon icon="bars"></font-awesome-icon>
          </template>
        </b-navbar-toggle>
      </b-navbar>
    </b-container>
    <b-sidebar id="sidebarMenu" bg-variant="sidebarMenu">
      <b-navbar-nav class="pl-4">
        <b-nav-item :to="{name: 'Home'}">Home</b-nav-item>
        <b-nav-item :to="{name: 'Teachers'}">For teachers</b-nav-item>
        <b-nav-item :to="{name: 'Students'}">For students</b-nav-item>
        <b-nav-item :to="{name: 'otherContent', params: {documentid: '1-fX3SDL6a6XUnKeNn7QcrGm4IzzFpVwxodILBiOX9GU'}}">Extra resources</b-nav-item>
        <b-nav-item :to="{name: 'otherContent', params: {documentid: '1QOutcRzC-QW0G8HRv1F-ursYY9HHsr9UMt1TjIHS3Sg'}}">Help</b-nav-item>
        <b-nav-item :to="{name: 'otherContent', params: {documentid: '18HOg3-OXGXn1QOJynnPvka9yB2l6tQhQEy1OuBXfVLY'}}">About</b-nav-item>
      </b-navbar-nav>
    </b-sidebar>
  </div>
</template>

<script>
import Logo from '@/components/logo'
export default {
  name: 'mainHeaderLanding',
  data () {
    return {
      showMenu: process.env.VUE_APP_SHOW_TEACHERS,
      specialCase: [
        '1j8AsEXU2LW31nuk3hApNJ7s4D4gjZHMFaVKdAHAPJqQ',
        '17TiN73BoxyPXeFcOfKkzWQNVV-wenk_5zLKm_zmjgIw',
        '1xs_e94MessOhRiCNgrb52-y2CUUkWPTfB8XpTmgGFW0'
      ]
    }
  },
  components: {
    Logo
  }
}
</script>

<style>
.bg-sidebarMenu {
  background-color: #ffe96f !important;
}

</style>

<style lang="scss" scoped>
@import '@/assets/styles/_colors.scss';

.container-navbar {
  background-color: #ffe96f;
}

.navbar-light .navbar-toggler {
  border-color: #ffe96f;
}
.nav-section {
  flex-direction: row;
  font-size: 16pt;
  color: $black;
}
.backTo {
  text-transform: uppercase;
  font-weight: bold;
  text-decoration: underline;
  & a {
    color: $black !important;
  }
  padding-right: 0.5rem;
}
.pipe {
  padding-right: 0.5rem;
}
.pipe, .lesson-type {
  color: $black;
}
#sidebarMenu {
  .navbar-nav {
    & .nav-link {
      color: #ab005c;
      text-transform: uppercase;
      font-weight: bold;
      font-size: 1.375rem;
    }
  }
}
#wideMenu {
  .navbar-nav {
    & .nav-link {
      color: #222222;
      text-transform: uppercase;
      font-weight: normal;
      font-size: 15pt;
    }
  }
}

@media (max-width: 767px) {
  .backTo {
    font-size: 15pt;
  }
  .lesson-type {
    font-size: 10pt;
    margin-top: 0.69rem;
  }
}
</style>
